import {cn} from "@adleritech/web-ui/utils";
import styles from "./Headline.module.css";

export type HeadlineProps = React.HTMLAttributes<HTMLDivElement>;

export function Headline({className, ...props}: HeadlineProps) {
    return <div className={cn(styles.wrapper, className)} {...props} />;
}
